<div *ngIf="contacts.length > 0; else placeholder" class="contact-listing__contacts">
  <app-contact *ngFor="let contact of contacts" [contact]="contact" class="contact-listing__contact"
               [remarks]="contact.type === ContactType.Owner ? ownerMgrRemarks : []"></app-contact>
</div>
<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">No contact information is available for this airport.</div>
  </div>
</ng-template>
